import script from "./NotificationMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMessages.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMessages.vue?vue&type=style&index=0&id=2a5129a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5129a1"]])

export default __exports__